import { Reducer, combineReducers } from 'redux';
import { RouterState, connectRouter } from 'connected-react-router';
import { AdminAppAction } from '../../actions';
import { AdminAppState } from '../../state';
import { History } from 'history';
import { adminModalsReducer } from '../admin-modals';
import { adminPanelsReducer } from '../admin-panels';
import { authReducer } from '../auth';
import { eventsReducer } from '../events';
import { imagesReducer } from '../images';
import { pagesReducer } from '../pages';
import { placesReducer } from '../places';
import { siteViewportReducer } from '../site-viewport';
import { wipReducer } from '../wip';

export interface CreateAdminAppReducerOptions {
  history: History;
}

export const createAdminAppReducer = ({
  history,
}: CreateAdminAppReducerOptions): Reducer<AdminAppState, AdminAppAction> =>
  combineReducers({
    auth: authReducer,
    events: eventsReducer,
    images: imagesReducer,
    modals: adminModalsReducer,
    pages: pagesReducer,
    panels: adminPanelsReducer,
    places: placesReducer,
    router: connectRouter(history) as Reducer<RouterState, AdminAppAction>,
    viewport: siteViewportReducer,
    wip: wipReducer,
  });
